export default defineNuxtPlugin(nuxtApp => {
  nuxtApp.hook('page:finish', () => {
    const connectifID = useRuntimeConfig().public.CONNECTIF_ID

    const connectifScript = document.createElement('script')
    connectifScript.id = `__cn_generic_script__${connectifID}`
    connectifScript.innerHTML = `!function(e){function t(){if(!e.querySelector("#__cn_client_script_${connectifID}")){var t=e.createElement("script");t.setAttribute("src","https://cdn.connectif.cloud/eu8/client-script/${connectifID}"),e.body.appendChild(t)}}"complete"===e.readyState||"interactive"===e.readyState?t():e.addEventListener("DOMContentLoaded",t)}(document);`

    document.body.prepend(connectifScript)
  })
})
